<template>
  <div id="app" :class="(dark) ? 'bg-sideDark' : 'bg-sideLight'">
    <div class="block lg:hidden">
      <div :class="(showSide) ? 'fixed w-full h-full bg-black opacity-75 z-10' : ''" @click="showSide = false"></div>
      <nav class="transition fixed h-screen z-20 top-0 overflow-auto" style="z-index: 9999" :class="[(showSide) ? 'show' : '', (dark) ? 'bg-sideDark' : 'bg-sideLight', ($i18n.locale == 'ar') ? 'msidenav right-0' : 'msidenavleft left-0']">
        <div class="cursor-pointer text-white p-4" @click="showSide = false">
          <svg class="fill-current inline-block" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
            <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path>
          </svg>
        </div>
        <MobileSidenav :dark="dark" @updateShowSide="editShowSide" />
      </nav>
    </div>
    <div class="absolute cursor-pointer" :class="[(dark) ? 'text-white' : 'text-black', ($i18n.locale == 'ar' ? 'top-left-2' : 'top-right-2')]" @click="activateDark" v-if="dark != true">
      <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" class="stroke-current" viewBox="0 0 512 512">
        <line x1="256" y1="48" x2="256" y2="96" style="fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:32px"/><line x1="256" y1="416" x2="256" y2="464" style="fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:32px"/><line x1="403.08" y1="108.92" x2="369.14" y2="142.86" style="fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:32px"/><line x1="142.86" y1="369.14" x2="108.92" y2="403.08" style="fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:32px"/><line x1="464" y1="256" x2="416" y2="256" style="fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:32px"/><line x1="96" y1="256" x2="48" y2="256" style="fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:32px"/><line x1="403.08" y1="403.08" x2="369.14" y2="369.14" style="fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:32px"/><line x1="142.86" y1="142.86" x2="108.92" y2="108.92" style="fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:32px"/><circle cx="256" cy="256" r="80" style="fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:32px"/>
      </svg>
    </div>
    <div class="absolute cursor-pointer" :class="[(dark) ? 'text-white' : 'text-black', ($i18n.locale == 'ar' ? 'top-left-2' : 'top-right-2')]" @click="desactivateDark" v-else>
      <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 512 512" class="stroke-current">
        <path d="M160,136c0-30.62,4.51-61.61,16-88C99.57,81.27,48,159.32,48,248c0,119.29,96.71,216,216,216,88.68,0,166.73-51.57,200-128-26.39,11.49-57.38,16-88,16C256.71,352,160,255.29,160,136Z" style="fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"/>
      </svg>
    </div>
    <div class="absolute cursor-pointer" :class="($i18n.locale == 'ar' ? 'top-left-4' : 'top-right-4')">
      <ul class="flex flex-wrap">
        <li v-for="item in langs" :key="item.code" @click="changeLocal(item.code)">
          <span :class="(dark) ? 'text-white' : 'text-black'" class="mx-1 lg:mx-2 px-1 lg:px-2 py-3 lg:py-2 inline-block font-bold text-sm lg:text-base" v-if="$i18n.locale != item.code">{{item.title}}</span>
        </li>
      </ul> 
    </div>
    <div class="flex flex-col lg:flex-row flex-wrap">
      <div class="w-full lg:w-1/12 hidden lg:block">
        <nav class="fixed w-1/12 h-screen" :class="(dark) ? 'bg-sideDark' : 'bg-sideLight'">
          <Sidenav :dark="dark" />
        </nav>
      </div>
      <div :class="[(dark) ? 'bg-bodyDark' : 'bg-bodyLight', ($i18n.locale == 'ar' ? 'lg:rounded-r-xl' : 'lg:rounded-l-xl')]" class="w-full lg:w-11/12 rounded-none">
        <div class="inline-block lg:hidden mb-16 cursor-pointer" @click="showSide = true" :class="(dark) ? 'text-white' : 'text-black'">
          <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 512 512" class="fill-current stroke-current inline-block relative" :class="$i18n.locale == 'ar' ? 'top-right-2' : 'top-left-2'"><line x1="80" y1="160" x2="432" y2="160" style="fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:32px"/><line x1="80" y1="256" x2="432" y2="256" style="fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:32px"/><line x1="80" y1="352" x2="432" y2="352" style="fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:32px"/></svg>
        </div>
        <vue-page-transition name="fade-in-left">
          <router-view :key="$route.fullPath"/>
        </vue-page-transition>
      </div>
    </div>

  </div>
</template>

<script>
import Sidenav from '@/components/Sidenav.vue'
import $ from 'jquery'
import MobileSidenav from '@/components/MobileSidenav.vue'

export default {
  name: 'App',
  data() {
    return {
      showSide: false,
      langs: [
        {code: "ar", title: "العربية"},
        {code: "fr", title: "Français"},
        {code: "en", title: "English"}
      ]
    }
  },
  components: {
    Sidenav,
    MobileSidenav
  },
  methods: {
    hardReload() {
      if (window.localStorage) {
        if (!localStorage.getItem('firstLoad') ) {
          localStorage['firstLoad'] = true;
          window.location.reload(true);
        }
        else
          localStorage.removeItem('firstLoad');
      }
    },
    editShowSide(e) {
      this.showSide = e
    },
    changeLocal(language) {
      this.$i18n.locale = language
      this.$router.push({
        params: {lang: language}
      })
      // this.$router.go()
      window.location.reload()
    },
    activateDark() {
      this.$store.commit('changeDark', true)
    },
    desactivateDark() {
      this.$store.commit('changeDark', false)
    }
  },
  created() {
    this.hardReload();
    let htmlEl = document.querySelector("html");
    let direction = (this.$i18n.locale == "ar") ? 'rtl' : 'ltr'
    htmlEl.setAttribute('dir',direction);
    htmlEl.setAttribute('lang', this.$i18n.locale);
  },
  computed: {
    dark () {
      return this.$store.state.dark
    }
  }
}
</script>

<style lang="scss">
  .msidenav { margin-right: -250px;width: 250px;
    &.show { margin-right: 0; }
  }
  .msidenavleft { margin-left: -250px; width: 250px;
    &.show { margin-left: 0; } 
  }
</style>